var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('a',{staticStyle:{"border-bottom":"1px dashed","text-decoration":"none","margin-left":"3px","margin-right":"3px"},on:{"click":function($event){return _vm.$emit('revisedClick', _vm.item.value)}}},[_vm._v(_vm._s(_vm.item.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }